// Study-specific overrides for canonical instruction screens.
//
// instructions.js checks these BEFORE the markdown lookup, so exporting a key here
// shadows the same-named screen in instruction_screens.md. Used sparingly and only
// where the canonical text has been overtaken by a design change.
//
// M0 — the recording sentence and its acknowledgment are removed. Both were written for
// a live proctored call, where confirming setup was the first thing that happened. The
// session now opens M0 → recording_check, and that next screen walks through starting a
// recording, sharing the entire screen and turning the camera on, with a separate
// checkbox for each. Asking here as well means confirming setup before being shown how.
//
// Everything else in the paragraph is KEPT: the timer behaviour, the no-going-back rule,
// and the docs link are stated nowhere else in the flow.
//
// Deviation from the 2026-07-20 fidelity rule — log it alongside the unproctored change.
// M1 — header only. The reassurance below it ("not a test you can fail", "use I'm not
// sure freely", "doesn't affect your payment") is dropped: the questions themselves each
// offer "I'm not sure" as an option, which makes the permission self-evident without
// spending a paragraph asserting it.
//
// Deviation from the 2026-07-20 fidelity rule — log with the others.
export const M1 = '**Concept quiz — about 5 minutes, no AI, no outside resources.**'

export const M0 = `
**Welcome back. This session takes about 80–90 minutes and runs in timed blocks:**

1. Short concept quiz *(no AI)*
2. Two learning tasks with an **AI tutor available** *(20 minutes each)*
3. A few quick questions
4. One programming task *(no AI)*
5. Short quiz *(no AI)* and a final survey

Each block has its own timer — when it ends, the platform moves you forward automatically. You can't return to earlier blocks. The official Trio documentation link in the sidebar is available throughout.
`.trim()
